<template>
  <div>
    <Field
      :ref="iModel.phone"
      v-slot="{ errors, field, value }"
      v-model="_phone"
      tag="div"
      :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@MOBILE_NUMBER'))"
      :rules="{ required: true, regex: PHONE_REGEX }"
    >
      <QInput
        v-bind="field"
        :model-value="value"
        :label="$t('ETAB.FORMS.LABELS.@MOBILE_NUMBER')"
        :name="iModel.phone"
        type="tel"
        :error="errors.length > 0"
        :error-message="errors[0]"
      />
    </Field>
  </div>
</template>

<script>
  import { Field } from "vee-validate";
  import { PHONE_REGEX } from "@core/helpers";

  export default {
    components: {
      Field,
    },
    props: {
      phone: { type: String, default: null },
      iModel: { type: Object, default: () => ({}) },
    },
    emits: ["update:phone"],
    computed: {
      _phone: {
        get() {
          return this.phone;
        },
        set(value) {
          this.$emit("update:phone", value);
        },
      },
    },
    created() {
      this.PHONE_REGEX = PHONE_REGEX;
    },
  };
</script>
